import { defineFieldDisplay } from "../defines";
import DatetimeDisplay from "./DatetimeDisplay.vue";

export default defineFieldDisplay({
  id: "datetime",
  component: DatetimeDisplay,
});
